import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { takeWhile } from "rxjs/operators";
import { LookupService } from "src/app/services/lookup.service";

@Component({
    selector: 'addcity-modal',
    templateUrl: './addcity.component.html',
    styleUrls: ['./addcity.component.css']
})

export class AddcityComponent implements OnInit, OnDestroy {
    isAlive: boolean = true;
    cityForm: UntypedFormGroup;
    states: any;
    allCityAndState: any;
    submitted: boolean;

    constructor(
        public dialogRef: MatDialogRef<AddcityComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: UntypedFormBuilder,
        private lookup: LookupService,
        private tostr: ToastrService
    ) {
        console.log('cities', this.states)
        this.cityForm = fb.group({
            "cityName": ['', [Validators.required, Validators.maxLength(100), Validators.pattern('^[a-zA-Z ]*$')]],
            "idStateMaster": ['', [Validators.required]]
        })
    }

    ngOnInit(): void {
        this.getStates()
    }

    getStates() {
        this.lookup.getStateList().pipe(takeWhile(() => this.isAlive)).subscribe(
            res => {
                this.states = res['data']
            }
        )
    }

    get f() {
        return this.cityForm.controls
    }

    addCity() {
        this.submitted = true
        if (this.cityForm.valid) {
            var obj = {
                "name": this.cityForm.get('cityName').value,
                "stateMasterIdStateMaster": Number(this.cityForm.get('idStateMaster').value)
            }
            this.lookup.addNewCity(obj).pipe(takeWhile(() => this.isAlive)).subscribe(
                res => {
                    if (res['data'] == 0) {
                        this.tostr.warning('CityMaster data Already exist.')
                    } else {
                        this.tostr.success('City added succesfully')
                        this.dialogRef.close('addedcity')
                    }


                }, err => {
                    console.log(err)
                }
            )
        }
    }


    restrictSpaceAtstart(event: any) {
        let inputChar = String.fromCharCode(event.charCode);
        let inputValue = event.target.value;

        if (inputValue.length === 0 && inputChar === ' ') {
            event.preventDefault();
            return;
        }
    }


    onCancel() {
        this.dialogRef.close()
    }

    ngOnDestroy(): void {
        this.isAlive = false
    }
}